import styled from 'styled-components';

export const Container = styled.div`
  span {
    font-size: 14px;
    font-family: 'Roboto';
    color: #f15a;
  }
`;
